<template>
  <div id="tags-view-container" class="tags-view-container" v-if="visitedViews.length>0">
    <scroll-pane ref="scrollPane" class="tags-view-wrapper">
      <router-link
        v-for="(tag,index) in visitedViews"
        ref="tag"
        :key="tag.path"
        :class="{'active':isActive(tag),'top-class':(activeIndex-1)==index || index==visitedViews.length-1}"
        :to="{ path: tag.path, query: tag.query, fullPath: tag.fullPath }"
        tag="span"
        class="tags-view-item"
        @click.middle.native="closeSelectedTag(tag)"
        @contextmenu.prevent.native="openMenu(tag,$event)"
      >
        {{ tag.title }}
        <span
          v-if="!tag.meta.affix"
          class="el-icon-close"
          @click.prevent.stop="closeSelectedTag(tag)"
        />
      </router-link>
    </scroll-pane>
    <ul v-show="visible" :style="{left:left+'px',top:top+'px'}" class="contextmenu">
      <li @click="refreshSelectedTag(selectedTag)">刷新</li>
      <li
        v-if="!(selectedTag.meta&&selectedTag.meta.affix)"
        @click="closeSelectedTag(selectedTag)"
      >关闭
      </li>
      <li @click="closeOthersTags">关闭其他</li>
      <li @click="closeAllTags(selectedTag)">关闭所有</li>
    </ul>
  </div>
</template>

<script>
    import ScrollPane from "./ScrollPane";
    import path from "path";

    export default {
        components: {ScrollPane},
        data() {
            return {
                visible: false,
                top: 0,
                left: 0,
                selectedTag: {},
                affixTags: []
            };
        },
        computed: {
            visitedViews() {
                let visitedViews = this.$store.state.tagsView.visitedViews;
                // console.log(visitedViews)
                return visitedViews;
            },
            activeIndex() {

                let visitedViews = this.$store.state.tagsView.visitedViews;
                for (let i = 0; i < visitedViews.length; i++) {
                    if (this.isActive(visitedViews[i])) {
                        return i;
                    }
                }
                return 0;
            }
        },
        watch: {
            $route() {
                this.addTags();
                this.moveToCurrentTag();
            },
            visible(value) {
                if (value) {
                    document.body.addEventListener('click', this.closeMenu)
                } else {
                    document.body.removeEventListener('click', this.closeMenu)
                }
            }
        },
        mounted() {
            this.addTags();
        },
        methods: {
            isActive(route) {
                return route.path === this.$route.path;
            },
            filterAffixTags(routes, basePath = "/") {
                let tags = [];
                routes.forEach(route => {
                    if (route.meta && route.meta.affix) {
                        const tagPath = path.resolve(basePath, route.path);
                        tags.push({
                            fullPath: tagPath,
                            path: tagPath,
                            name: route.name,
                            meta: {...route.meta}
                        });
                    }
                    if (route.children) {
                        const tempTags = this.filterAffixTags(route.children, route.path);
                        if (tempTags.length >= 1) {
                            tags = [...tags, ...tempTags];
                        }
                    }
                });
                return tags;
            },
            initTags() {
                const affixTags = (this.affixTags = this.filterAffixTags(this.routes));
                for (const tag of affixTags) {
                    // Must have tag name
                    if (tag.name) {
                        this.$store.dispatch("tagsView/addVisitedView", tag);
                    }
                }
            },
            addTags() {
                const {name} = this.$route;
                if (name == "empty") {
                    return false;
                }

                if (name) {
                    this.$store.dispatch("tagsView/addView", this.$route);
                }
                return false;
            },
            moveToCurrentTag() {
                const tags = this.$refs.tag;
                this.$nextTick(() => {
                    for (const tag of tags) {
                        if (tag.to.path === this.$route.path) {
                            this.$refs.scrollPane.moveToTarget(tag);
                            // when query is different then update
                            if (tag.to.fullPath !== this.$route.fullPath) {
                                this.$store.dispatch("tagsView/updateVisitedView", this.$route);
                            }
                            break;
                        }
                    }
                });
            },
            refreshSelectedTag(view) {
                this.$store.dispatch("tagsView/delCachedView", view).then(() => {
                    const {fullPath} = view;
                    this.$nextTick(() => {
                        this.$router.replace({
                            path: "/redirect" + fullPath
                        });
                    });
                });
            },
            closeSelectedTag(view) {
                this.$store
                    .dispatch("tagsView/delView", view)
                    .then(({visitedViews}) => {
                        if (this.isActive(view)) {
                            this.toLastView(visitedViews, view);
                        }
                    });
            },
            closeOthersTags() {
                this.$router.push(this.selectedTag);
                this.$store
                    .dispatch("tagsView/delOthersViews", this.selectedTag)
                    .then(() => {
                        this.moveToCurrentTag();
                    });
            },
            closeAllTags(view) {
                this.$store.dispatch("tagsView/delAllViews").then(({visitedViews}) => {
                    if (this.affixTags.some(tag => tag.path === view.path)) {
                        return;
                    }
                    this.toLastView(visitedViews, view);
                });
            },
            toLastView(visitedViews, view) {

                const latestView = visitedViews.slice(-1)[0];
                // console.log(latestView)
                if (latestView) {
                    if (latestView.path == "/battery/index" || latestView.path == "/battery/index/") {
                        this.$router.push({path: "/battery/index"});
                    } else {
                        this.$router.push(latestView);
                    }
                } else {
                    this.$router.push("/empty");
                    // // now the default is to redirect to the home page if there is no tags-view,
                    // // you can adjust it according to your needs.
                    // if (view.name === "Dashboard") {
                    //   // to reload home page
                    //   this.$router.replace({ path: "/redirect" + view.fullPath });
                    // } else {
                    //   this.$router.push("/");
                    // }
                }
            },
            openMenu(tag, e) {
                // debugger
                const menuMinWidth = 105;
                const offsetLeft = this.$el.getBoundingClientRect().left; // container margin left
                const offsetWidth = this.$el.offsetWidth; // container width
                const maxLeft = offsetWidth - menuMinWidth; // left boundary
                const left = e.clientX - offsetLeft + 15; // 15: margin right
                // console.log(offsetLeft,e.clientX,this.$el.offsetWidth)
                if (left > maxLeft) {
                    this.left = maxLeft;
                } else {
                    this.left = left;
                }
                this.left = e.clientX -200;
                this.top = e.clientY-50;
                this.visible = true;
                this.selectedTag = tag;
            },
            closeMenu() {
                this.visible = false;
            }
        }
    };
</script>

<style lang="scss" scoped>
  .tags-view-container {

    height: 40px;
    width: 100%;
    background: #fff;
    margin-bottom: 16px;
    margin-top: 0px;
    position: sticky;
    left: 0;
    top: 0;
    z-index: 1999;
    box-shadow: 0px 4px 16px 0 rgba(182, 186, 193, 0.15);

    .tags-view-wrapper {
      .tags-view-item {
        display: inline-block;
        position: relative;
        cursor: pointer;
        // width: 204px;
        height: 40px;
        line-height: 40px;
        color: #9A9DA7;
        background: #f3f5f8;
        width: 143px;
        padding: 0;
        // padding-left: 14px;
        border-top-left-radius: 6px;
        border-top-right-radius: 6px;

        padding: 0 0px;
        padding-left: 15px;
        padding-right: 6px;
        font-size: 12px;

        &::after {
          content: "";
          display: inline-block;
          width: 1px;
          height: 16px;
          background: #CFD0D5;
          border-radius: 1px;
          position: absolute;
          right: 0;
          top: 13px;
        }
        &.top-class::after{
          background-color: transparent;
        }
        .el-icon-close {
          color: #9A9DA7;
          width: 20px;
          height: 20px;
          float: right;
          margin-right: 0px;
          line-height: 38px;

          &:hover {
            background-color: transparent;
          }
        }

        // margin-left: 5px;
        // margin-top: 4px;
        &:first-of-type {
          // margin-left: 0px;
        }

        &:last-of-type {
          // margin-right: 15px;
        }

        [data-theme*="theme2"] & {
          &.active {
            color: #0066FF;
            background: linear-gradient(#83b3fc, #F4F6F9);
            width: 143px;
            padding: 0;
            padding-left: 15px;
            padding-right: 6px;
            border-top-left-radius: 6px;
            border-top-right-radius: 6px;
            // border-color: #0060aa;
            border-bottom: none;
            font-size: 12px;

            .el-icon-close {
              color: #10152D;
              width: 20px;
              height: 20px;
              float: right;
              margin-right: 0px;
              line-height: 38px;

              &:hover {
                background-color: transparent;
              }
            }

            &::after {
              content: "";
              display: inline-block;
              width: 1px;
              height: 16px;
              background: transparent;
              border-radius: 1px;
              position: absolute;
              right: 0;
              top: 13px;
              // margin-right: 2px;
            }
          }
        }

      }


    }

    .contextmenu {
      margin: 0;
      background: #fff;
      z-index: 3000;
      position: absolute;
      list-style-type: none;
      padding: 5px 0;
      border-radius: 4px;
      font-size: 12px;
      font-weight: 400;
      color: #10152D;
      box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);

      li {
        margin: 0;
        padding: 0px 16px;
        height: 40px;
        line-height: 40px;
        font-size: 14px;
        cursor: pointer;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        &:hover {
          background: #F5F9FF;
          color: #0066FF;
        }
      }
    }
  }
</style>

<style lang="scss">
  //reset element css of el-icon-close
  .tags-view-wrapper {
    .tags-view-item {
      .el-icon-close {
        width: 16px;
        height: 16px;
        vertical-align: 2px;
        border-radius: 50%;
        text-align: center;
        transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
        transform-origin: 100% 50%;

        &:before {
          transform: scale(1);
          display: inline-block;
          vertical-align: -3px;
        }

        &:hover {
          background-color: #b4bccc;
          color: #fff;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/TagsView/index.vue